import React, {Component} from 'react';
import {checkEmailAvailability, checkEmailAvailabilityNotIn, request,getEczanelerByIlce,getIlceler,getCity} from "../../util/APIUtils";
import {
    deepCopyObject,
    filterCities,
    filterCitiesNew,
    getCitySubdivisions,
    showAxiosError,
    trimObject
} from "../../util/Helpers";
import {DatePicker, Form, input, Switch} from "antd";
import Select from "../../local_node_modules/react-select"
import Alert from "react-s-alert";
import {validateComponent, validateField} from "../../common/validation";
import moment from "moment";
import {Label, UncontrolledTooltip} from "reactstrap";
import './MemberList.css';
import {API_BASE_URL} from "../../constants";
import LoadingIndicator from "../../common/LoadingIndicator";
import Maskedinput from "react-text-mask";
import emailMask from "text-mask-addons/dist/emailMask";
import Uploader2 from "../../components/Uploader/Uploader2";
import 'react-datetime/css/react-datetime.css';
import _ from 'lodash';


const {TextArea} = input;

class NewMemberCreate extends Component{
    constructor(props){
        super(props);
        this.state = {
            error: {},
            emailAvailabilityError: {},
            page: 0,
            size: 10,
            manual: false,
            loading: false,
            isLoading: false,
            authRoles: [],
            fieldsDisabled: false,
            citySelectionDisabled: false,
            mode: this.props.mode,
            outstandingAccruals: [],
            inActivateMemberModal: false,
            isPreviouslyInactivated: false,
            townOptions: [],
            pharmacyOptions: [],
            memberInfo: {
                id: null,
                ad: "",
                soyad: "",
                eskiSoyad: "",
                tcKimlikNo: "",
                dogumTarihi: null,
                kimlikTipi: "",
                cuzdanKimlikSeriNo: "",
                kayitNo: "",
                kimlikSonGecerlilikTarihi: null,
                babaAdi: "",
                anaAdi: "",
                dogumYeri: "",
                medeniHali: "",
                kanGrubu: "",
                eposta: "",
                evTel: "",
                gsmTel: "",
                isTel: "",
                isAdres: "",
                ikametAdres: "",
                odaKayitTarihi: "",
                odaSicilNo: "",
                universite: "",
                belgeTuru: "",
                mezuniyetTarihi: null,
                diplomaNo: "",
                gozRuhTarih: null,
                gozRuhNo: "",
                gozRuhKurum: "",
                ruhsatTarihi: null,
                ruhsatNo: "",
                vergiDairesiAd: "",
                vergiNo: "",
                fotoFile: "",
                kimlikCuzdanFile: "",
                adliSicilFile: "",
                ruhsatnameFile: "",
                diplomaFile: "",
                ikametgahFile: "",
                fotoThumbFile: "",
                calismaBelgesiFile: "",
                uyelikDurdurmaDilekceFile: "",
                taahhutBelgesiFile: "",
                taahhutBelgesiThumbFile: "",
                kayitDilekceFile:"",
                ozgecmisFile:"",
                imzaSirküsFile:"",
                taahhutBelgesiPath: "",
                kimlikCuzdanThumbFile: "",
                adliSicilThumbFile: "",
                ruhsatnameThumbFile: "",
                diplomaThumbFile: "",
                ikametgahThumbFile: "",
                calismaBelgesiThumbFile: "",
                uyelikDurdurmaDilekceThumbFile: "",
                kayitDilekceThumbFile:"",
                ozgecmisThumbFile:"",
                imzaSirküsThumbFile:"",
                fotoPath: "",
                kimlikCuzdanPath: "",
                adliSicilPath: "",
                ruhsatnamePath: "",
                diplomaPath: "",
                ikametgahPath: "",
                calismaBelgesiPath: "",
                uyelikDurdurmaDilekcePath: "",
                kayitDilekcePath:"",
                ozgecmisPath:"",
                imzaSirküsPath:"",
                basvuruDurumu: "",
                uyeTipi:"",
                uyeEczaneAcilis:"",
                basvuruReddedilmeSebebi: "",
                ruhsatAktif: true,
                uyelikAktif: true,
                borcuVar: false,
                uyeCalisiyor: true,
                taahhut: false,
                kendiIsyeri: false,
                mesulMudur: false,
                kamuPersoneli: false,
                eczaci: false,
                temsilci: false,
                unemployed: false,
                uyelikPasiflikNedeni: "",
                user_id: "",
                username: "",
                email: "",
                cinsiyet: "",
                muesseseAdi: "",
                muesseseSahibi: "",
                isTransferred: false,
                calismaBelgeli: false,
                townSelection: null,
                pharmacySelection: null,
                city: {
                    id: null,
                    plakaKod: null,
                    ad: null,
                    oda: {
                        id: null,
                        ad: null,
                        adres: null,
                        telefonNo: null,
                        email: null,
                        webSitesiURL: null,
                        kurulusKararNo: null
                    }
                },
                addressList: [
                    {
                        id: null,
                        addressType: 'PERMANENT',
                        addressString: null,
                        semt: null,
                        cityId: null,
                        citysubdivisionId: null,
                        memberId: null,
                    },
                    {
                        id: null,
                        addressType: 'WORK',
                        addressString: null,
                        semt: null,
                        cityId: null,
                        citysubdivisionId: null,
                        memberId: null
                    }
                ]
            },
            fileInfo: {
                kimlikCuzdanFileName: "kimlikCuzdanFile",
                adliSicilFileName: "adliSicilFile",
                ruhsatnameFileName: "ruhsatnameFile",
                diplomaFileName: "diplomaFile",
                ikametgahFileName: "ikametgahFile",
                fotoFileName: "fotoFile",
                calismaBelgesiFileName: "calismaBelgesiFile",
                uyelikDurdurmaDilekceFileName: "uyelikDurdurmaDilekceFile",
                taahhutBelgesiFileName: "taahhutBelgesiFile",
                kayitDilekceFileName:"kayitDilekceFile",
                ozgecmisFileName:"ozgecmisFile",
                imzaSirüsFileName:"imzaSirüsFile"
            },
            permanentAdrsCities: null,
            workAdrsCities: null,
            permanentAdrsCitySubdivisions: null,
            workAdrsCitySubdivisions: null,
            odaId:null,
        };



        this.saveMember = this.saveMember.bind(this);
        this.cancelProcess = this.cancelProcess.bind(this);
        this.onChangeMember = this.onChangeMember.bind(this);
        this.validateClass = this.validateClass.bind(this);
        this.validateMessage = this.validateMessage.bind(this);
        this.validateField = this.validateField.bind(this);
        this.onCityInfoChange = this.onCityInfoChange.bind(this);
        this.onChangeCheck = this.onChangeCheck.bind(this);
        this.getUserInfo = this.getUserInfo.bind(this);
        this.validateEmailClass = this.validateEmailClass.bind(this);
        this.validateEmailField = this.validateEmailField.bind(this);
        this.onChangeAddress = this.onChangeAddress.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
        this.onChangeCheckBox = this.onChangeCheckBox.bind(this);
        this.onChangeDateString = this.onChangeDateString.bind(this);
        this.checkTransferState = this.checkTransferState.bind(this);
        this.onChangeUnemployedCheck = this.onChangeUnemployedCheck.bind(this);
        this.loadTowns =  this.loadTowns.bind(this);
        this.loadPharmacies=this.loadPharmacies.bind(this);
        this.loadCities=this.loadCities.bind(this);
        this.saveDraft=this.saveDraft.bind(this);
        this.loadDraft=this.loadDraft.bind(this);
        }

        componentDidMount() {
            if (this.state.mode === 'review' ) {
                this.setState({ fieldsDisabled: true });
            }
            console.log("baran deneme currentuser", this.props);

            
            const { selectedMember } = this.props;
            
            if (selectedMember && (selectedMember.basvuruDurumu === "UYELIK_BILGILERININ_KONTROLU_BEKLENIYOR" || selectedMember.basvuruDurumu === "ODA_YETKILISI_ONAYI_BEKLENIYOR")) {
                this.setState({ fieldsDisabled: true }, () => {
                    Alert.error('Üyelik başvurunuz kontrol/onay aşamasındadır.', {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 5000
                    });
                });
            } else if (selectedMember && selectedMember.basvuruDurumu === "ONAYLANDI") {
                this.setState({ fieldsDisabled: true }, () => {
                    Alert.success('Başvurunuz onaylanmıştır.', {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 5000
                    });
                });
            }



            if (this.props.selectedMember) {
                let citySelectionDisabled = true;
                let selectedMember = deepCopyObject(this.props.selectedMember);
            
                selectedMember.addressList = selectedMember.addressList || [];
            
                let permanentAdrsCitySubdivisions = (selectedMember.addressList.length > 0) ? getCitySubdivisions(selectedMember.addressList[0].cityId, this.props.citySubdivisions) : null;
                let workAdrsCitySubdivisions = (selectedMember.addressList.length > 1) ? getCitySubdivisions(selectedMember.addressList[1].cityId, this.props.citySubdivisions) : null;
            
                let permanentAdrsCities = filterCities(this.props.cities, 1000);
                let workAdrsCities = (this.props.currentUser.realm === 0) ? filterCities(this.props.cities, 1000) : filterCities(this.props.cities, this.props.currentUser.realm);
                let isPreviouslyInactivated = !selectedMember.uyelikAktif;
            
                if (selectedMember.addressList.length === 0) {
                    selectedMember.addressList.push({
                            id: null,
                            addressType: 'PERMANENT',
                            addressString: null,
                            semt: null,
                            cityId: null,
                            citysubdivisionId: null,
                            memberId: selectedMember.id,
                        },
                        {
                            id: null,
                            addressType: 'WORK',
                            addressString: null,
                            semt: null,
                            cityId: null,
                            citysubdivisionId: null,
                            memberId: selectedMember.id,
                        });
                }
            
                selectedMember.belgeTuru = (selectedMember.belgeTuru === "" || selectedMember.belgeTuru === null) ? 'DIPLOMA' : selectedMember.belgeTuru;
                selectedMember.odaKayitTarihi = (selectedMember.odaKayitTarihi !== null && selectedMember.odaKayitTarihi !== "") ? moment.utc(selectedMember.odaKayitTarihi, "YYYY-MM-DD") : null;
            
                this.setState({
                    memberInfo: selectedMember,
                    citySelectionDisabled,
                    permanentAdrsCitySubdivisions,
                    workAdrsCitySubdivisions,
                    permanentAdrsCities,
                    workAdrsCities,
                    isPreviouslyInactivated
                });
            
                if (selectedMember.isTransferred === true) {
                    this.setState({ fieldsDisabled: true });
                }
            
               this.getUserInfo();
            } else {
                console.log("this.props.cities: ", this.props.cities);
                let permanentAdrsCities = (this.props.currentUser.realm === 0) ? filterCitiesNew(this.props.cities, 1000) : filterCitiesNew(this.props.cities, 1000);
                let workAdrsCities = (this.props.currentUser.realm === 0) ? filterCitiesNew(this.props.cities, 1000) : filterCitiesNew(this.props.cities, this.props.currentUser.realm);
                this.setState({ permanentAdrsCities, workAdrsCities });
            }
            
            this.loadTowns();
            this.loadCities();
            this.listCitySubdivisions();
            this.loadDraft();
        }



        

        loadTowns() {
            getIlceler()
                .then(response => {
                    const townOptions = response.data.map(town => ({
                        label: town.townName,
                        value: town.id
                    }));

                    townOptions.sort((a, b) => a.label.localeCompare(b.label));

                    this.setState({ townOptions });
                }).catch(error => {
                    showAxiosError(error);
                });
        }

        loadPharmacies(townId) {
            getEczanelerByIlce(townId)
                .then(response => {
                    const pharmacyOptions = response.data.pharmacies.map(pharmacy => ({
                        label: pharmacy.name,
                        value: pharmacy.id
                    }));

                    pharmacyOptions.sort((a, b) => a.label.localeCompare(b.label));

                    this.setState({ pharmacyOptions });
                }).catch(error => {
                    showAxiosError(error);
                });
        }
        loadCities() {
            getCity()
                .then(response => {
                    const cities = response.data.map(city => ({
                        label: city.ad,
                        value: city.id,
                        oda:{
                            id: city.odaId
                        }
                    }));
                    let permanentAdrsCities = (this.props.currentUser.realm === 0) ? filterCitiesNew(cities, 1000) : filterCitiesNew(cities, 1000);
                    let workAdrsCities = (this.props.currentUser.realm === 0) ? filterCitiesNew(cities, 1000) : filterCitiesNew(cities, this.props.currentUser.realm);
                    let odaId = workAdrsCities && workAdrsCities.find(item => item.value === String(item.oda.id));
                    this.setState({ workAdrsCities: workAdrsCities, permanentAdrsCities: permanentAdrsCities, odaId: odaId.value });
                    this.onCityInfoChange("id", odaId);
                    this.onChangeMemberLowerCase("username", this.props.currentUser.username);
                    this.onChangeMemberLowerCase("email", this.props.currentUser.email)

                })
                .catch(error => {
                    console.error('Error fetching cities:', error);
                });
        }
        listCitySubdivisions() {
            let self = this;
            let params = {
                url: API_BASE_URL + "/city-subdivision",
                method: "get",
            };
            request(params)
                .then(function (response) {
                    let citySubdivisions = response.data;
                    self.setState({
                        citySubdivisions,
                        "workAdrsCitySubdivisions": citySubdivisions.map(item => ({
                            value: item.id.toString(),
                            label: item.name
                        })),
                    });
                }).catch(function (error) {
                showAxiosError(error);
            });
        }

        getUserInfo() {
            let self = this;
            let params = {
                url: API_BASE_URL + "/user/id/" + this.props.selectedMember.user_id,
                method: "get",
            };
            request(params)
                .then(function (response) {
                    let userInfo = response.data;
                    self.setState({
                        userInfo,
                    });
                }).catch(function (error) {
                showAxiosError(error);
            });
        }
        checkTransferState() {
            if (this.state.memberInfo.transferTo !== undefined && this.state.memberInfo.transferTo !== null) {
                let msg = "Üyenin Bekleyen Transfer İşlemi Bulunmaktadır. Üyelik Durumu Değiştirilemez!";
                Alert.error(msg, {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 10000
                });
                return true;
            }
            return false;
        }
        onChangeUnemployedCheck(name, value) {
            let memberInfo = _.cloneDeep(this.state.memberInfo);
            let addressList = memberInfo.addressList;
            let permanentAdrsCities = null;
            let permanentAdrsCitySubdivisions = null;
            memberInfo[name] = value;

            if (name === 'unemployed') {
                permanentAdrsCities = (this.props.currentUser.realm === 0) ? filterCities(this.props.cities, 1000) : (value) ? filterCities(this.props.cities, 1000) : filterCities(this.props.cities, this.props.currentUser.realm);
                permanentAdrsCitySubdivisions = null;
                addressList[0]['cityId'] = null;
                addressList[0]['citysubdivisionId'] = null;

                if (value) {
                    memberInfo['kendiIsyeri'] = false;
                    memberInfo['mesulMudur'] = false;
                    memberInfo['kamuPersoneli'] = false;
                    memberInfo['eczaci'] = false;
                    memberInfo['temsilci'] = false;
                    memberInfo['unemployed'] = true;
                    memberInfo['muesseseSahibi'] = null;
                    memberInfo['muesseseAdi'] = null;
                    memberInfo['isTel'] = null;
                    memberInfo['vergiDairesiAd'] = null;
                    memberInfo['vergiNo'] = null;
                    memberInfo['ruhsatNo'] = null;
                    memberInfo['ruhsatTarihi'] = "";
                    addressList[1]['citysubdivisionId'] = null;
                    addressList[1]['cityId'] = null;
                    addressList[1]['addressString'] = null;
                    addressList[1]['semt'] = null;
                }
                console.log(memberInfo, addressList);
            }
            this.setState({memberInfo, permanentAdrsCities, permanentAdrsCitySubdivisions});
        }

        onChangeCheck(name, value) {
            let memberInfo = _.cloneDeep(this.state.memberInfo);

            if (this.checkTransferState()) {
                return;
            }

            let addressList = memberInfo.addressList;
            let permanentAdrsCities = null;
            let permanentAdrsCitySubdivisions = null;

            memberInfo[name] = value;

            if (name === 'uyeCalisiyor') {
                permanentAdrsCities = (this.props.currentUser.realm === 0) ? filterCities(this.props.cities, 1000) : (value) ? filterCities(this.props.cities, 1000) : filterCities(this.props.cities, this.props.currentUser.realm);
                permanentAdrsCitySubdivisions = null;
                addressList[0]['cityId'] = null;
                addressList[0]['citysubdivisionId'] = null;

                if (!value) { //çalışma durumu pasife çekilirse tüm iş yeri bilgilerini boş olarak set  et
                    memberInfo['kendiIsyeri'] = false;
                    memberInfo['mesulMudur'] = false;
                    memberInfo['kamuPersoneli'] = false;
                    memberInfo['eczaci'] = false;
                    memberInfo['temsilci'] = false;
                    memberInfo['unemployed'] = true;
                    memberInfo['muesseseSahibi'] = null;
                    memberInfo['muesseseAdi'] = null;
                    memberInfo['isTel'] = null;
                    memberInfo['vergiDairesiAd'] = null;
                    memberInfo['vergiNo'] = null;
                    memberInfo['ruhsatNo'] = null;
                    memberInfo['ruhsatTarihi'] = "";
                    addressList[1]['citysubdivisionId'] = null;
                    addressList[1]['cityId'] = null;
                    addressList[1]['addressString'] = null;
                    addressList[1]['semt'] = null;
                }
                console.log(memberInfo, addressList);
            }
            this.setState({memberInfo, permanentAdrsCities, permanentAdrsCitySubdivisions});
        }

        validateField(e) {
            let id = e.target.id;
            let rule = e.target.dataset.vdata;
            let boundary = e.target.dataset.vlength;
            let value = e.target.value;
            let result = validateField(rule, boundary, value);
            let error = this.state.error;
            error = Object.assign(error, {[id]: result});
            this.setState({error});
        }

        async validateEmailField(e) {
            let id = e.target.id;
            let rule = e.target.dataset.vdata;
            let boundary = e.target.dataset.vlength;
            let recordId = this.props.selectedMember ? this.props.selectedMember.user_id : null;
            let value = e.target.value;
            let result = validateField(rule, boundary, value);
            let error = this.state.error;
            let emailAvailabilityError = this.state.emailAvailabilityError;
            error = Object.assign(error, {[id]: result});
            //console.log("error",error);
            if (recordId !== null) {
                await checkEmailAvailabilityNotIn(value, recordId)
                    .then(response => {
                        if (response.data.available) {
                            //              console.log("true");
                            error = Object.assign(error, {[id]: {valid: true, message: ''}});
                            emailAvailabilityError = Object.assign(emailAvailabilityError, {
                                [id]: {
                                    valid: true,
                                    message: ''
                                }
                            });
                            this.setState({error, emailAvailabilityError});
                        } else {
                            //console.log("false");
                            error = Object.assign(error, {[id]: {valid: false, message: 'e-posta kullanımdadır!'}});
                            emailAvailabilityError = Object.assign(emailAvailabilityError, {
                                [id]: {
                                    valid: false,
                                    message: 'e-posta kullanımdadır!'
                                }
                            });
                            this.setState({error, emailAvailabilityError});
                        }
                    }).catch(() => {
                        error = Object.assign(error, {[id]: {valid: true, message: ''}});
                        emailAvailabilityError = Object.assign(emailAvailabilityError, {[id]: {valid: true, message: ''}});
                        this.setState({error, emailAvailabilityError});
                    });
            } else {
                await checkEmailAvailability(value)
                    .then(response => {
                        if (response.data.available) {
                            //console.log("true");
                            error = Object.assign(error, {[id]: {valid: true, message: ''}});
                            emailAvailabilityError = Object.assign(emailAvailabilityError, {
                                [id]: {
                                    valid: true,
                                    message: ''
                                }
                            });
                            this.setState({error, emailAvailabilityError});
                        } else {
                            // console.log("false");
                            error = Object.assign(error, {[id]: {valid: false, message: 'e-posta kullanımdadır!'}});
                            emailAvailabilityError = Object.assign(emailAvailabilityError, {
                                [id]: {
                                    valid: false,
                                    message: 'e-posta kullanımdadır!'
                                }
                            });
                            this.setState({error, emailAvailabilityError});
                        }
                    }).catch(() => {
                        error = Object.assign(error, {[id]: {valid: true, message: ''}});
                        emailAvailabilityError = Object.assign(emailAvailabilityError, {[id]: {valid: true, message: ''}});
                        this.setState({error, emailAvailabilityError});
                    });

            }
        }


        validateClass(id) {
            let error = this.state.error;
            return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
        }

        validateEmailClass(id) {
            let error = this.state.emailAvailabilityError;
            return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
        }

        validateMessage(id) {

            if (id === 'tGsmTel') {
                const value = this.state.memberInfo.gsmTel || "";
                if (value.length !== 10) {
                    return "10 rakam olarak yazılmalı";
                }
            }
            if (id === 'tWorkAdresCitySub') {
                const value = this.state.memberInfo.addressList[1] && this.state.memberInfo.addressList[1].citysubdivisionId;
                if (!value) {
                    return "İlçe seçimi zorunludur";
                }
            }
            let error = this.state.error;
            return (error[id] === undefined ? '' : (error[id].message));
        }

        validateComponent() {
            let result = validateComponent(this);
            this.setState({
                error: result.error
            });
            return result
        }

        onChangeMember(name, value) {

            if (value instanceof moment) {
                value = moment.utc(value.format('DD.MM.YYYY').toString() + " 00:00", "DD.MM.YYYY HH:mm");
            }
            let memberInfo = this.state.memberInfo;
            memberInfo[name] = value;
            this.setState({memberInfo});
        }

        onChangeDateString(name, value) {
            if (value === "") {
                value = null;
            }
            if (value !== null) {
                let splitted = value.split(".");
                value = splitted[2] + "-" + splitted[1] + "-" + splitted[0];
            }
            let memberInfo = this.state.memberInfo;
            memberInfo[name] = value;
            this.setState({memberInfo});
        }

        // onChangeMemberUpperCase(name, value) {
        //     let memberInfo = this.state.memberInfo;
        //     memberInfo[name] = value.toString().toLocaleUpperCase();
        //     this.setState({memberInfo});
        // }
        onChangeMemberUpperCase(name, value) {
            let memberInfo = this.state.memberInfo;
        
            let upperValue = value
                .replace(/i/g, 'İ')   
                .replace(/ı/g, 'I')   
                .toUpperCase();      
        
            memberInfo[name] = upperValue;
            this.setState({ memberInfo });
        }
      
        
        onChangeMemberLowerCase(name, value) {
            let memberInfo = this.state.memberInfo;
            if (name === 'username') {
                value = value.toString().replace('@', '');
            }
            memberInfo[name] = value.toString().toLocaleLowerCase();
            this.setState({memberInfo});
        }

        onChangeCheckBox(name, value) {
            let memberInfo = this.state.memberInfo;
            memberInfo[name] = value;

            if (name === 'kendiIsyeri' && value) {
                memberInfo['muesseseSahibi'] = memberInfo['ad'] + ' ' + memberInfo['soyad'];
                memberInfo['mesulMudur'] = true;
                memberInfo['calismaBelgeli'] = false;

            } else if (name === 'calismaBelgeli' && value) {
                memberInfo['mesulMudur'] = false;
                memberInfo['kendiIsyeri'] = false;

            } else if (name === 'mesulMudur' && value) {
                memberInfo['calismaBelgeli'] = false;
            }

            if (memberInfo['kendiIsyeri']) //işyeri sahibiyse mesul müdür true olsun.
            {
                memberInfo['mesulMudur'] = true;
            }

            if (memberInfo['calismaBelgeli'] === false) {
                memberInfo['calismaBelgesiPath'] = null;
                memberInfo['calismaBelgesiFile'] = null;
                memberInfo['calismaBelgesiThumbFile'] = null;
            }

            this.setState({memberInfo});
        }


        onChangeAddress(name, value, index, type) {
            console.log("name,value,index,type", name, value, index, type);
            let addressInfo = this.state.memberInfo.addressList;
            if (type === 'string') {
                addressInfo[index][name] = value.toString().toLocaleUpperCase();
            } else {//select
                if (value === null) {
                    addressInfo[index][name] = null;
                } else {
                    addressInfo[index][name] = value.value;
                }

                if (name === 'cityId') {
                    if (index === 0) {
                        (value !== null) ? this.setState({permanentAdrsCitySubdivisions: getCitySubdivisions(value.value, this.state.citySubdivisions)}) : this.setState({permanentAdrsCitySubdivisions: null});
                    } else if (index === 1) {
                        (value !== null) ? this.setState({workAdrsCitySubdivisions: getCitySubdivisions(value.value, this.state.citySubdivisions)}) : this.setState({workAdrsCitySubdivisions: null});
                    }
                    addressInfo[index]['citysubdivisionId'] = null;
                }
            }

            this.setState({addressInfo});
        }





        onCityInfoChange(name, value) {
            let cityInfo = this.state.memberInfo.city;
            if (value === null) {
                cityInfo[name] = null;
            } else {
                cityInfo[name] = value.value;
                cityInfo["ad"] = value.label;
                cityInfo["oda"]["id"] = this.state.workAdrsCities[0].oda.id;
            }
            this.setState({cityInfo});

        }


        onSelectChange(name, value) {
            let memberInfo = this.state.memberInfo;
            if (value === null) {
                memberInfo[name] = null;
            } else {
                memberInfo[name] = value.value;
            }

            this.setState({ memberInfo }, () => {
                if (name === "townSelection") {
                    this.loadPharmacies(value.value);
                }
            });
        }




        saveMember(action) {
            let self = this;
            let params;
            let data;
            let message;
            let validity = this.validateComponent();
            let validity_ = this.validateMemberInfo();

            if (validity.valid && validity_ === '') {
                self.setState({isLoading: true});
                let member = deepCopyObject(this.state.memberInfo);
                member = trimObject(member);

                switch(action) {
                    case "ONAYLA":
                    case "KAYDET":
                        member.basvuruDurumu = "ONAYLANDI";
                        break;
                    case "IADE":
                        member.basvuruDurumu = "UYELIK_BILGILERININ_TAMAMLANMASI_BEKLENIYOR";
                        break;
                    case "RED":
                        member.basvuruDurumu = "REDDEDILDI";
                        break;
                    case "ONAYA_GONDER":
                        member.basvuruDurumu = "UYELIK_BILGILERININ_KONTROLU_BEKLENIYOR";
                        break;
                    default:
                        member.basvuruDurumu = "UYELIK_BILGILERININ_TAMAMLANMASI_BEKLENIYOR";
                }

                data = member;

                if (member.id === null) {
                    message = 'Uye Bilgileri Başarıyla Kaydedildi.';
                    params = {
                        url: API_BASE_URL + "/uye/",
                        data: data,
                        method: 'post'
                    };
                } else {
                    if (action === "ONAYLA" || action === "RED" || action === "IADE") {
                        message = 'Uye Durumu Başarıyla Güncellendi.';
                        params = {
                            url: API_BASE_URL + "/uye/updateStatus/" + member.id + "/" + member.basvuruDurumu,
                            data: data,
                            method: 'put'
                        };
                    } else {
                        message = 'Uye Bilgileri Başarıyla Güncellendi.';
                        params = {
                            url: API_BASE_URL + "/uye/update-by-admin/",
                            data: data,
                            method: 'put'
                        };
                    }
                }

                request(params).then(() => {
                    Alert.success(
                        message, {
                            position: 'top-right',
                            effect: 'stackslide',
                            timeout: 5000
                        });
                    self.setState({isLoading: false});
                    this.cancelProcess();
                    if (typeof this.props.handleSearch === 'function') {
                        self.props.handleSearch(self.props.searchQuery, true);
                    }
                }).catch(function (error) {
                    self.setState({isLoading: false});
                    showAxiosError(error);
                });
            } else {
                validity_ = 'Hatalı Alanlar var! </br>' + validity_;
                Alert.error(
                    validity_, {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 20000
                    });
            }
        }


        validateMemberInfo() {
            let memberInfo = this.state.memberInfo;
            let errorMessage = '';
            if (memberInfo.username === null || memberInfo.username.toString().trim() === '') {
                errorMessage += 'Kullanıcı Adı Giriniz!</br>';
            }

            if (memberInfo.username !== null && memberInfo.username.toString().trim().length < 6) {
                errorMessage += 'Kullanıcı Adı En Az 6 Hane Uzunluğunda Olmalıdır!</br>';
            }
            if (memberInfo.email === null || memberInfo.email.toString().trim() === '') {
                errorMessage += 'E-posta Adresi Giriniz!</br>';
            }


            if (memberInfo.ad === null || memberInfo.ad.toString().trim() === '') {
                errorMessage += 'Ad Boş Olamaz!</br>';
            }

            if (memberInfo.soyad === null || memberInfo.soyad.toString().trim() === '') {
                errorMessage += 'Soyad Boş Olamaz!</br>';
            }

            if (memberInfo.tcKimlikNo === null) {
                errorMessage += 'TC Kimlik No Boş Olamaz!</br>';
            }

            if (memberInfo.tcKimlikNo.toString().trim().length !== 11) {
                errorMessage += 'TC Kimlik No Alanı 11 Hane Uzunluğunda Olmalıdır!</br>';
            }

            if (memberInfo.kimlikTipi === null) {
                errorMessage += 'Kimlik Tipi Seçiniz!</br>';
            }

            if (memberInfo.kimlikTipi === "TCKimlikKarti") {
                if (memberInfo.kimlikSonGecerlilikTarihi === null) {
                    errorMessage += 'Kimlik Son Geçerlilik Tarihi Seçiniz!</br>';
                }
            } else if (memberInfo.kimlikTipi === "NufusCuzdani") {
                if (memberInfo.kayitNo === null || memberInfo.kayitNo.toString().trim() === '') {
                    errorMessage += 'Kimlik Kayıt No Giriniz!</br>';
                }
            }

            if (memberInfo.anaAdi === null || memberInfo.anaAdi.toString().trim() === '') {
                errorMessage += 'Ana Adı Boş Olamaz!</br>';
            }

            if (memberInfo.babaAdi === null || memberInfo.babaAdi.toString().trim() === '') {
                errorMessage += 'Baba Adı Boş Olamaz!</br>';
            }

            if (memberInfo.cuzdanKimlikSeriNo === null || memberInfo.cuzdanKimlikSeriNo.toString().trim() === '') {
                errorMessage += 'Nüfus Cüzdanı/TC Kimlik Seri No Boş Olamaz!</br>';
            }


            if (memberInfo.dogumYeri === null || memberInfo.dogumYeri.toString().trim() === '') {
                errorMessage += 'Doğum Yeri Boş Olamaz!</br>';
            }


            if (memberInfo.dogumTarihi === null || memberInfo.dogumTarihi === '') {
                errorMessage += 'Dogum Tarihi Boş Olamaz!</br>';
            }


            if (memberInfo.medeniHali === null || memberInfo.medeniHali === '') {
                errorMessage += 'Medeni Hali Boş Olamaz!</br>';
            }
            if(memberInfo.citySubDivisionId===null || memberInfo.citySubDivisionId==='')
            {
                errorMessage += 'Oda İlçe Boş Olamaz!</br>'  ;
            }
            if (memberInfo.gsmTel === null || memberInfo.gsmTel.toString().trim() === '') {
                errorMessage += 'GSM Tel Boş Olamaz!</br>';
            }
            if (memberInfo.cinsiyet === null) {
                errorMessage += 'Cinsiyet Seçiniz!</br>';
            }
            if (memberInfo.belgeTuru === null) {
                errorMessage += 'Mezuniyet Belge Türü Seçiniz!</br>';
            }
            if (memberInfo.uyeTipi === null) {
                errorMessage += 'Üye Tipini Seçiniz!</br>';
            }
            if (memberInfo.uyeEczaneAcilis === null) {
                errorMessage += 'Açılış Sebebini Seçiniz!</br>';
            }
            if (memberInfo.uyeEczaneAcilis === "YENI_IS_YERİ_ACMAK_ISTIYORUM") {
                errorMessage += ' Lütfen Eczane İşlemleri menüsünden iş yeri bilgilerinizi giriniz!</br>';
            }
            if (!memberInfo.uyelikAktif) {
                if (memberInfo.uyelikPasiflikNedeni === null || memberInfo.uyelikPasiflikNedeni.toString().trim() === '')
                    errorMessage += 'İlişik Kesme Sebebi Giriniz!</br>';
            }

            if (!memberInfo.uyeCalisiyor) {
                if (memberInfo.uyelikDurdurmaDilekcePath === null || memberInfo.uyelikDurdurmaDilekcePath.toString() === '')
                    errorMessage += 'Pasife Alma Dilekçesi Yükleyiniz!</br>';
            }

            return errorMessage;
        }

        cancelProcess() {
            if (typeof this.props.cancelProcess === 'function') {
                this.props.cancelProcess();
            }
        }

        handleLogout() {
            this.props.handleLogout();
        }

    

        saveDraft() {
            const { memberInfo } = this.state;
            localStorage.setItem('memberDraft', JSON.stringify(memberInfo));
            Alert.success("Taslak başarıyla kaydedildi.", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 5000
            });
        }

        loadDraft() {
            const draft = localStorage.getItem('memberDraft');
            if (draft) {
                this.setState({ memberInfo: JSON.parse(draft) });
            }
        }

        render() {

            const cinsiyetOptions = [
                {label: 'BELİRTİLMEMİŞ', value: 'BELIRTILMEMIS'},
                {label: 'ERKEK', value: 'ERKEK'},
                {label: 'KADIN', value: 'KADIN'},
            ]

            const medeniHalOptions = [
                {label: 'BEKAR', value: 'BEKAR'},
                {label: 'EVLI', value: 'EVLI'},
                {label: 'DUL', value: 'DUL'}
            ]

            const KimlikTipiOptions = [
                {label: 'Nüfus Cüzdanı', value: 'NufusCuzdani'},
                {label: 'TC Kimlik Kartı', value: 'TCKimlikKarti'}
            ]


        const BelgeTipiOptions = [
            {label: 'Diploma', value: 'DIPLOMA'},
            {label: 'Geçici Mezuniyet Belgesi', value: 'GECICI_MEZUNIYET'}
        ]

        const BasvuruDurumuOptions = [
            {label: 'Üyelik Bilgilerinin Tamamlanması Bekleniyor', value: 'UYELIK_BILGILERININ_TAMAMLANMASI_BEKLENIYOR'},
            {label: 'Üyelik Bilgilerinin Kontrolü Bekleniyor', value: 'UYELIK_BILGILERININ_KONTROLU_BEKLENIYOR'},
            {label: 'Oda Yetkilisi Onayı Bekleniyor', value: 'ODA_YETKILISI_ONAYI_BEKLENIYOR'},
            {label: 'Onaylandı', value: 'ONAYLANDI'},
            {label: 'Reddedildi', value: 'REDDEDILDI'}

        ]

        const UyeTipiOptions = [
            {label: 'Eczane Sahibi ve Mesul Müdür', value: 'ECZANE_SAHIBI_VE_MESUL_MUDUR'},
            {label: 'Eczane Sahibi', value: 'ECZANE_SAHIBI'},
            {label: 'Mesul Müdür', value: 'MESUL_MUDUR'},
            {label: 'İkinci Eczacı', value: 'IKINCI_ECZACI'},
            {label: 'Yardımcı Eczacı', value: 'YARDIMCI_ECZACI'},
            {label: 'Gönüllü Üye', value: 'GONULLU_UYE'}
        ]

        const UyeEczaneAcilisOptions = [
            {label: 'Yeni İş Yeri Açmak İstiyorum', value: 'YENI_IS_YERİ_ACMAK_ISTIYORUM'},
            {label: 'Mevcut Eczane/Ecza Deposunda Çalışmak İstiyorum', value: 'MEVCUT_ECZANE_ECZA_DEPOSUNDA_CALISMAK_ISTIYORUM'},
            {label: 'Mevcut Eczane/Ecza Deposunu Devralmak İstiyorum', value: 'MEVCUT_ECZANE_ECZA_DEPOSUNU_DEVRALMAK_ISTIYORUM'},
            {label: 'Gönüllü Üyeyim', value: 'GONULLU_UYEYIM'},

        ]

        let tDogumTarihi = this.state.memberInfo.dogumTarihi ? {value: moment.utc(this.state.memberInfo.dogumTarihi, "YYYY-MM-DD")} : {};
        let tKimlikSonGecerlilikTarihi = this.state.memberInfo.kimlikSonGecerlilikTarihi ? {value: moment.utc(this.state.memberInfo.kimlikSonGecerlilikTarihi, "YYYY-MM-DD")} : {};
        let tMezuniyetTarihi = this.state.memberInfo.mezuniyetTarihi ? {value: moment.utc(this.state.memberInfo.mezuniyetTarihi, "YYYY-MM-DD")} : {};
        let tGozRuhTarih = this.state.memberInfo.gozRuhTarih ? {value: moment.utc(this.state.memberInfo.gozRuhTarih, "YYYY-MM-DD")} : {};
        let tRuhsatTarihi = this.state.memberInfo.ruhsatTarihi ? {value: moment.utc(this.state.memberInfo.ruhsatTarihi, "YYYY-MM-DD")} : {};
        let tOdaKayitTarihi = this.state.memberInfo.odaKayitTarihi ? {value: this.state.memberInfo.odaKayitTarihi} : {};
        return (
            <div className="memberForm--main-container">
                {   (this.state.isLoading) &&
                    <div className="loader">
                        <LoadingIndicator />
                    </div>
                }
                  <div className="memberForm-container">
                    <Form>
                        <div className="FormRenk col-sm-12">
                            <span className="form-title">Oda/Portal Giriş Bilgileri</span>
                            <div className="row">
                                <Label className="col-sm-3">Oda İl: *</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tCity')}>
                                    <Select
                                        className="basic-single"
                                        disabled={this.state.citySelectionDisabled || this.state.memberInfo.id === null}
                                        classNamePrefix="select"
                                        placeholder="İl seçiniz."
                                        isClearable={false}
                                        isSearchable={true}
                                        name="city"
                                        id="tCity"
                                        ref="tCity"
                                        onBlur={this.validateField}
                                        style={{width: 160, minWidth: 160}}
                                        inputProps={{'vdata': "required"}}
                                        // options={this.state.workAdrsCities}
                                        options={this.state.workAdrsCities && this.state.workAdrsCities.filter(item => item.value === String(item.oda.id))}
                                        onChange={(value) => this.onCityInfoChange("id", value)}
                                        value={String(this.props.currentUser.realm)}
                                        />
                                    {this.validateMessage('tCity') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tCity" delay={0}>
                                        {this.validateMessage("tCity")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>
                            {(this.state.memberInfo.id !== null) &&
                            <div className='row'>
                                <label className="col-sm-3">SicilNo: </label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tOdaSicilNo')}>
                                    <input className="form-control"
                                           disabled={true}
                                           type="text"
                                           name="odaSicilNo"
                                           id="tOdaSicilNo"
                                           maxLength="9"
                                           data-vlength="9"
                                           value={this.state.memberInfo.odaSicilNo}
                                    />
                                    {this.validateMessage('tOdaSicilNo') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tOdaSicilNo" delay={0}>
                                        {this.validateMessage("tOdaSicilNo")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>
                            }

                            <div className='row'>
                                <label className="col-sm-3">Kullanıcı Adı: *</label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tUsername')}>
                                    <input className="form-control uppercase"
                                        disabled={this.state.fieldsDisabled || this.state.memberInfo.id === null}
                                        type="text"
                                        name="username"
                                        id="tUsername"
                                        maxLength="50"
                                        data-vlength="6,50"
                                        onBlur={this.validateField}
                                        ref="tUsername"
                                        // value={this.state.memberInfo.username || ""}
                                        defaultValue={this.props.currentUser.username}
                                        onChange={(e) => this.onChangeMemberLowerCase("username", e.target.value)} />
                                    {this.validateMessage('tUsername') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tUsername" delay={0}>
                                            {this.validateMessage("tUsername")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>

                            <div className='row'>
                                <label className="col-sm-3">E-posta *</label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tEmail')}>
                                    <Maskedinput className="form-control"
                                        disabled={this.state.fieldsDisabled || this.state.memberInfo.id === null}
                                        type="text"
                                        mask={emailMask}
                                        name="email"
                                        inputProps={{ vdata: "email", vlength: '1,255' }}
                                        id="tEmail"
                                        onBlur={() => this.validateField({
                                            target: {
                                                id: "tEmail",
                                                dataset: { vdata: "email", vlength: '1,255' },
                                                value: this.state.memberInfo.email
                                            }
                                        })}
                                        placeholder="_________@______.___"
                                        ref="tEmail"
                                        // value={this.state.memberInfo.email}
                                        defaultValue={this.props.currentUser.email}
                                        onChange={(e) => this.onChangeMemberLowerCase("email", e.target.value)} />
                                    {this.validateMessage('tEmail') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tEmail" delay={0}>
                                            {this.validateMessage("tEmail")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">Mezuniyet Belge Tipi:*</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tBelgeTuru')}>
                                    <Select
                                        className="basic-single"
                                        disabled={this.state.fieldsDisabled}
                                        defaultValue={{ label: 'DİPLOMA', value: 'DIPLOMA' }}
                                        classNamePrefix="select"
                                        placeholder="Seçiniz"
                                        isClearable={false}
                                        isSearchable={false}
                                        name="belgeTuru"
                                        id="tBelgeTuru"
                                        ref="tBelgeTuru"
                                        style={{ flex: 1 }}
                                        inputProps={{ 'vdata': "required" }}
                                        options={BelgeTipiOptions}
                                        onChange={(value) => this.onSelectChange("belgeTuru", value)}
                                        value={this.state.memberInfo.belgeTuru} />
                                    {this.validateMessage('tBelgeTuru') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tBelgeTuru" delay={0}>
                                            {this.validateMessage("tBelgeTuru")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>

                            {
                                (this.state.memberInfo.belgeTuru === 'DIPLOMA') &&
                                <div>
                                    <div className="row">
                                        <Label className="col-sm-3">Üniversite:</Label>
                                        <div className={"col-sm-8 form-group" + this.validateClass('tUniversite')}>
                                            <input className="form-control"
                                                type="text"
                                                disabled={this.state.fieldsDisabled}
                                                name="universite"
                                                id="tUniversite"
                                                maxLength="50"
                                                value={this.state.memberInfo.universite || ""}
                                                onChange={(e) => this.onChangeMemberUpperCase("universite", e.target.value)} />
                                            {this.validateMessage('tUniversite') !== "" &&
                                                <UncontrolledTooltip placement="right" target="tUniversite" delay={0}>
                                                    {this.validateMessage("tUniversite")}
                                                </UncontrolledTooltip>}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <Label className="col-sm-3">Diploma No/Mezuniyet Tarihi:</Label>
                                        <div className={"col-sm-4 form-group" + this.validateClass('tDiplomaNo')}>
                                            <input className="form-control"
                                                type="text"
                                                disabled={this.state.fieldsDisabled}
                                                name="diplomaNo"
                                                id="tDiplomaNo"
                                                maxLength="50"
                                                style={{ flex: 1 }}
                                                value={this.state.memberInfo.diplomaNo || ""}
                                                onChange={(e) => this.onChangeMemberUpperCase("diplomaNo", e.target.value)} />
                                            {this.validateMessage('tDiplomaNo') !== "" &&
                                                <UncontrolledTooltip placement="right" target="tDiplomaNo" delay={0}>
                                                    {this.validateMessage("tDiplomaNo")}
                                                </UncontrolledTooltip>}
                                        </div>
                                        <div className={"col-sm-4 form-group" + this.validateClass('tMezuniyetTarihi')}>
                                            <DatePicker {...tMezuniyetTarihi}
                                                        className="basic-single"
                                                        placeholder="Tarih seçiniz."
                                                        disabled={this.state.fieldsDisabled}
                                                        classNamePrefix="select"
                                                        format="DD.MM.YYYY"
                                                        isClearable={true}
                                                        isSearchable={true}
                                                        style={{flex: 1}}
                                                        name="mezuniyetTarihi"
                                                        onChange={(date, dateString) => this.onChangeDateString("mezuniyetTarihi", dateString)}/>
                                            {this.validateMessage('tMezuniyetTarihi') !== "" &&
                                            <UncontrolledTooltip placement="right" target="tMezuniyetTarihi" delay={0}>
                                                {this.validateMessage("tMezuniyetTarihi")}
                                            </UncontrolledTooltip>}
                                        </div>
                                    </div>
                                </div>
                            }

                            {
                                 (this.state.memberInfo.belgeTuru === 'GECICI_MEZUNIYET') &&
                                 <div className="row">
                                     <Label className="col-sm-3">Mezun Olacağınız Tarih:</Label>
                                     <div className={"col-sm-8 form-group" + this.validateClass('tMezuniyetTarihi')}>
                                         <DatePicker {...tMezuniyetTarihi}
                                                     className="basic-single"
                                                     placeholder="Tarih seçiniz."
                                                     disabled={this.state.fieldsDisabled}
                                                     classNamePrefix="select"
                                                     format="DD.MM.YYYY"
                                                     isClearable={true}
                                                     isSearchable={true}
                                                     style={{flex: 1}}
                                                     name="mezuniyetTarihi"
                                                     onChange={(date, dateString) => this.onChangeDateString("mezuniyetTarihi", dateString)}/>
                                         {this.validateMessage('tMezuniyetTarihi') !== "" &&
                                         <UncontrolledTooltip placement="right" target="tMezuniyetTarihi" delay={0}>
                                             {this.validateMessage("tMezuniyetTarihi")}
                                         </UncontrolledTooltip>}
                                     </div>
                                 </div>
                            }
                        </div>

                        <div className="FormRenk col-sm-12">
                            <span className="form-title">Üye Durumu</span>
                            <div>
                                {this.props.currentUser.realm === 0 &&
                                    this.state.memberInfo.id !== null && (
                                        <div className="row">
                                            <Label className="col-sm-3">Üyeliği Dondurulsun Mu?</Label>
                                            <div className={"col-sm-8 form-group" + this.validateClass('tUyeCalisiyor')}>
                                                <Switch checked={this.state.memberInfo.uyeCalisiyor}
                                                    disabled={this.state.fieldsDisabled}
                                                    checkedChildren="Hayır"
                                                    unCheckedChildren="Evet"
                                                    style={{ width: 150 }}
                                                    onChange={(e) => this.onChangeCheck("uyeCalisiyor", e)} />
                                            </div>
                                        </div>
                                    )}

                                 
                            <div className="row">
                                <Label className="col-sm-3">Başvuru Durumu :</Label>
                                <div className="col-sm-8 form-group">
                                    <input className="form-control"
                                        type="text"
                                        name="basvuruDurumu"
                                        id="tBasvuruDurumu"
                                        disabled={true}
                                        value={(BasvuruDurumuOptions.find(option => option.value === this.state.memberInfo.basvuruDurumu) || {}).label || ''} />
                                </div>
                            </div>


                                <div className="row">
                                    <Label className="col-sm-3">Üye Tipi : *</Label>
                                    <div className={"col-sm-8 form-group" + this.validateClass('tUyeTipi')}>
                                        <Select
                                            className="basic-single"
                                            disabled={this.state.fieldsDisabled}
                                            classNamePrefix="select"
                                            placeholder="Seçiniz"
                                            isClearable={false}
                                            isSearchable={false}
                                            name="uyeTipi"
                                            id="tUyeTipi"
                                            ref="tUyeTipi"
                                            style={{ width: 160, minWidth: 160 }}
                                            inputProps={{ 'vdata': "required" }}
                                            options={UyeTipiOptions}
                                            onChange={(value) => this.onSelectChange("uyeTipi", value)}
                                            value={this.state.memberInfo.uyeTipi} />
                                        {this.validateMessage('tUyeTipi') !== "" &&
                                            <UncontrolledTooltip placement="right" target="tUyeTipi" delay={0}>
                                                {this.validateMessage("tUyeTipi")}
                                            </UncontrolledTooltip>}
                                    </div>
                                </div>

                                <div className="row">
                                    <Label className="col-sm-3">Üye Olma Sebebi:*</Label>
                                    <div className={"col-sm-8 form-group" + this.validateClass('tUyeEczaneAcilis')}>
                                        <Select
                                            className="basic-single"
                                            disabled={this.state.fieldsDisabled}
                                            classNamePrefix="select"
                                            placeholder="Seçiniz"
                                            isClearable={false}
                                            isSearchable={false}
                                            name="uyeEczaneAcilis"
                                            id="tUyeEczaneAcilis"
                                            ref="tUyeEczaneAcilis"
                                            style={{ width: 160, minWidth: 160 }}
                                            inputProps={{ 'vdata': "required" }}
                                            options={UyeEczaneAcilisOptions}
                                            onChange={(value) => this.onSelectChange("uyeEczaneAcilis", value)}
                                            value={this.state.memberInfo.uyeEczaneAcilis} />
                                        {this.validateMessage('tUyeEczaneAcilis') !== "" &&
                                            <UncontrolledTooltip placement="right" target="tUyeEczaneAcilis" delay={0}>
                                                {this.validateMessage("tUyeEczaneAcilis")}
                                            </UncontrolledTooltip>}
                                    </div>
                                </div>
                                {(this.state.memberInfo.uyeEczaneAcilis === 'MEVCUT_ECZANE_ECZA_DEPOSUNDA_CALISMAK_ISTIYORUM' || this.state.memberInfo.uyeEczaneAcilis === 'MEVCUT_ECZANE_ECZA_DEPOSUNU_DEVRALMAK_ISTIYORUM') && (
                                    <div>
                                        <div className="row">
                                            <Label className="col-sm-3">İlçe Seçimi:*</Label>
                                            <div className={"col-sm-8 form-group" + this.validateClass('tTownSelection')}>
                                                <Select
                                                    className="basic-single"
                                                    disabled={this.state.fieldsDisabled}
                                                    classNamePrefix="select"
                                                    placeholder="İlçe seçiniz"
                                                    isClearable={false}
                                                    isSearchable={true}
                                                    name="townSelection"
                                                    id="tTownSelection"
                                                    ref="tTownSelection"
                                                    style={{ width: 160, minWidth: 160 }}
                                                    inputProps={{ 'vdata': "required" }}
                                                    options={this.state.townOptions}
                                                    onChange={(value) => this.onSelectChange("townSelection", value)}
                                                    value={this.state.memberInfo.townSelection} />
                                                {this.validateMessage('tTownSelection') !== "" &&
                                                    <UncontrolledTooltip placement="right" target="tTownSelection" delay={0}>
                                                        {this.validateMessage("tTownSelection")}
                                                    </UncontrolledTooltip>}
                                            </div>
                                        </div>

                                        <div className="row">
                                            <Label className="col-sm-3">Eczane Seçimi:*</Label>
                                            <div className={"col-sm-8 form-group" + this.validateClass('tPharmacySelection')}>
                                                <Select
                                                    className="basic-single"
                                                    disabled={this.state.fieldsDisabled}
                                                    classNamePrefix="select"
                                                    placeholder="Eczane seçiniz"
                                                    isClearable={false}
                                                    isSearchable={true}
                                                    name="pharmacySelection"
                                                    id="tPharmacySelection"
                                                    ref="tPharmacySelection"
                                                    style={{ width: 160, minWidth: 160 }}
                                                    inputProps={{ 'vdata': "required" }}
                                                    options={this.state.pharmacyOptions}
                                                    onChange={(value) => this.onSelectChange("pharmacySelection", value)}
                                                    value={this.state.memberInfo.pharmacySelection} />
                                                {this.validateMessage('tPharmacySelection') !== "" &&
                                                    <UncontrolledTooltip placement="right" target="tPharmacySelection" delay={0}>
                                                        {this.validateMessage("tPharmacySelection")}
                                                    </UncontrolledTooltip>}
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <div className="row">
                                    <Label className="col-sm-3">Kamu Personeli mi?:</Label>
                                    <div className={"col-sm-8 form-group" + this.validateClass('tKamuPersoneli')}>
                                        <input
                                            name="chkKamuPersoneli"
                                            disabled={this.state.fieldsDisabled || !this.state.memberInfo.uyeCalisiyor}
                                            type="checkbox"
                                            checked={this.state.memberInfo.kamuPersoneli}
                                            onChange={(e) => this.onChangeCheckBox("kamuPersoneli", e.target.checked)} />
                                    </div>
                                </div>
                                {
                                    this.state.memberInfo.id !== null && (
                                        <div className="row">
                                            <Label className="col-sm-3">Oda ile İlişiği Kesilsin Mi?</Label>
                                            <div className={"col-sm-8 form-group" + this.validateClass('tUyelikAktif')}>
                                                <Switch checked={this.state.memberInfo.uyelikAktif}
                                                    disabled={this.state.isPreviouslyInactivated || this.state.fieldsDisabled}
                                                    checkedChildren="Aktif(Devam Ediyor)"
                                                    unCheckedChildren="Pasif(İlişik Kesildi)"
                                                    style={{ width: 150 }}
                                                    onChange={(e) => {
                                                        this.state.memberInfo.uyelikAktif
                                                            ?
                                                            this.setState({ inActivateMemberModal: true })
                                                            :
                                                            this.onChangeCheck("uyelikAktif", e)
                                                    }} />
                                            </div>
                                        </div>
                                    )
                                }
                                {
                                    this.state.memberInfo.id !== null && (
                                        <div className="row">
                                            <Label className="col-sm-3">Taahhütlü mü ?:</Label>
                                            <div className={"col-sm-8 form-group" + this.validateClass('tTaahhut')}>
                                                <Switch checked={this.state.memberInfo.taahhut}
                                                    disabled={this.state.fieldsDisabled}
                                                    checkedChildren="Evet"
                                                    unCheckedChildren="Hayır"
                                                    style={{ width: 150 }}
                                                    onChange={(e) => this.onChangeCheck("taahhut", e)} />
                                            </div>
                                        </div>
                                    )
                                }
                                <div className="row">
                                    <Label className="col-sm-3">İşsiz mi?:</Label>
                                    <div className={"col-sm-8 form-group" + this.validateClass('tUnemployed')}>
                                        <Switch checked={this.state.memberInfo.unemployed}
                                            disabled={this.state.fieldsDisabled}
                                            checkedChildren="Evet"
                                            unCheckedChildren="Hayır"
                                            style={{ width: 150 }}
                                            onChange={(e) => this.onChangeUnemployedCheck("unemployed", e)} />
                                    </div>
                                </div>
                                {
                                    (!this.state.memberInfo.uyelikAktif) &&
                                    <div className="row">
                                        <Label className="col-sm-3">İlişik Kesme Nedeni: *</Label>
                                        <div
                                            className={"col-sm-8 form-group" + this.validateClass('tUyelikPasiflikNedeni')}>
                                            <TextArea className="form-control"
                                                type="text"
                                                name="uyelikPasiflikNedeni"
                                                id="tUyelikPasiflikNedeni"
                                                maxLength="255"
                                                disabled={this.state.isPreviouslyInactivated || this.state.fieldsDisabled}
                                                value={this.state.memberInfo.uyelikPasiflikNedeni}
                                                onChange={(e) => this.onChangeMemberUpperCase("uyelikPasiflikNedeni", e.target.value)} />
                                            {this.validateMessage('tUyelikPasiflikNedeni') !== "" &&
                                                <UncontrolledTooltip placement="right" target="tUyelikPasiflikNedeni"
                                                    delay={0}>
                                                    {this.validateMessage("tUyelikPasiflikNedeni")}
                                                </UncontrolledTooltip>}
                                        </div>
                                    </div>
                                }
                                {(this.state.memberInfo.taahhut) &&
                                    <div className="row">
                                        <Label className="col-sm-3">Taahhüt Belgesi: *</Label>
                                        <div className="col-sm-8 form-group">
                                            <Uploader2 onInfoChange={this.onChangeMember}
                                                fileName="taahhutBelgesiFile"
                                                thumbFileName="taahhutBelgesiThumbFile"
                                                filePathName="taahhutBelgesiPath"
                                                pathPrefix="taahhutbelgesi"
                                                memberTCKN={this.state.memberInfo.tcKimlikNo}
                                                filePath={this.state.memberInfo.taahhutBelgesiPath}
                                                file={this.state.memberInfo.taahhutBelgesiFile}
                                                thumb={this.state.memberInfo.taahhutBelgesiThumbFile}
                                                isDisabled={this.state.fieldsDisabled} />
                                        </div>
                                    </div>}
                                {this.props.currentUser.realm === 0 && (!this.state.memberInfo.uyeCalisiyor) &&
                                    <div className="row">
                                        <Label className="col-sm-3">Pasife Alma Dilekçesi: *</Label>
                                        <div className="col-sm-8 form-group">
                                            <Uploader2 onInfoChange={this.onChangeMember}
                                                fileName="uyelikDurdurmaDilekceFile"
                                                thumbFileName="uyelikDurdurmaDilekceThumbFile"
                                                filePathName="uyelikDurdurmaDilekcePath"
                                                pathPrefix="durdurma"
                                                memberTCKN={this.state.memberInfo.tcKimlikNo}
                                                filePath={this.state.memberInfo.uyelikDurdurmaDilekcePath}
                                                file={this.state.memberInfo.uyelikDurdurmaDilekceFile}
                                                thumb={this.state.memberInfo.uyelikDurdurmaDilekceThumbFile}
                                                isDisabled={this.state.fieldsDisabled} />
                                        </div>
                                    </div>}
                            </div>
                        </div>

                        <div className="FormRenk col-sm-12">
                            <span className="form-title">Kimlik Bilgileri</span>
                            <div className="row">
                                <Label className="col-sm-3">Adı: *</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tAd')}>
                                    <input className="form-control"
                                        disabled={this.state.fieldsDisabled}
                                        type="text"
                                        name="ad"
                                        id="tAd"
                                        maxLength="50"
                                        data-vlength="1,50"
                                        onBlur={this.validateField}
                                        ref="tAd"
                                        value={this.state.memberInfo.ad || ""}
                                        onChange={(e) => this.onChangeMemberUpperCase("ad", e.target.value)} />
                                    {this.validateMessage('tAd') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tAd" delay={0}>
                                            {this.validateMessage("tAd")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Soyadı */Eski Soyadı:</Label>
                                <div className={"col-sm-4 form-group" + this.validateClass('tSoyad')}>
                                    <input className="form-control"
                                        type="text"
                                        disabled={this.state.fieldsDisabled}
                                        name="soyad"
                                        id="tSoyad"
                                        maxLength="50"
                                        data-vlength="1,50"
                                        onBlur={this.validateField}
                                        ref="tSoyad"
                                        value={this.state.memberInfo.soyad || ""}
                                        onChange={(e) => this.onChangeMemberUpperCase("soyad", e.target.value)} />
                                    {this.validateMessage('tSoyad') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tSoyad" delay={0}>
                                            {this.validateMessage("tSoyad")}
                                        </UncontrolledTooltip>}
                                </div>
                                <div className={"col-sm-4 form-group" + this.validateClass('tEskiSoyad')}>
                                    <input className="form-control"
                                        type="text"
                                        disabled={this.state.fieldsDisabled}
                                        name="eskiSoyad"
                                        id="tEskiSoyad"
                                        maxLength="50"
                                        data-vlength="1,50"
                                        value={this.state.memberInfo.eskiSoyad || ""}
                                        onChange={(e) => this.onChangeMemberUpperCase("eskiSoyad", e.target.value)} />
                                    {this.validateMessage('tEskiSoyad') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tEskiSoyad" delay={0}>
                                            {this.validateMessage("tEskiSoyad")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">TC Kimlik No: *</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tTckNo')}>
                                    <input className="form-control"
                                        type="text"
                                        disabled={this.state.fieldsDisabled}
                                        name="tckNo"
                                        id="tTckNo"
                                        maxLength="11"
                                        data-vlength="11"
                                        onBlur={() => this.validateField({
                                            target: {
                                                id: "tTckNo",
                                                dataset: { vdata: "identifier", vlength: '11' },
                                                value: this.state.memberInfo.tcKimlikNo
                                            }
                                        })}
                                        ref="tTckNo"
                                        value={this.state.memberInfo.tcKimlikNo || ""}
                                        onChange={(e) => this.onChangeMember("tcKimlikNo", e.target.value)} />
                                    {this.validateMessage('tTckNo') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tTckNo" delay={0}>
                                            {this.validateMessage("tTckNo")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">Doğum Tarihi: *</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tDogumTarihi')}>
                                    <DatePicker {...tDogumTarihi}
                                                className="basic-single"
                                                placeholder="Tarih seçiniz."
                                                disabled={this.state.fieldsDisabled}
                                                classNamePrefix="select"
                                                format="DD.MM.YYYY"
                                                isClearable={true}
                                                isSearchable={true}
                                                name="dogumTarihi"
                                                id="tDogumTarihi"
                                                ref="tDogumTarihi"
                                                style={{width: 160}}
                                                inputProps={{'vdata': "required"}}
                                                onChange={(date, dateString) => this.onChangeDateString("dogumTarihi", dateString)}/>
                                    {this.validateMessage('tDogumTarihi') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tDogumTarihi" delay={0}>
                                        {this.validateMessage("tDogumTarihi")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Cinsiyet: *</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tCinsiyet')}>
                                    <Select
                                        className="basic-single"
                                        disabled={this.state.fieldsDisabled}
                                        classNamePrefix="select"
                                        placeholder="Seçiniz"
                                        isClearable={false}
                                        isSearchable={false}
                                        name="cinsiyet"
                                        id="tCinsiyet"
                                        ref="tCinsiyet"
                                        style={{ width: 160, minWidth: 160 }}
                                        inputProps={{ 'vdata': "required" }}
                                        options={cinsiyetOptions}
                                        onChange={(value) => this.onSelectChange("cinsiyet", value)}
                                        value={this.state.memberInfo.cinsiyet} />
                                    {this.validateMessage('tCinsiyet') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tCinsiyet" delay={0}>
                                            {this.validateMessage("tCinsiyet")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">Baba Adı: *</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tBabaAdi')}>
                                    <input className="form-control"
                                        type="text"
                                        disabled={this.state.fieldsDisabled}
                                        name="babaAdi"
                                        id="tBabaAdi"
                                        maxLength="50"
                                        data-vlength="1,50"
                                        onBlur={this.validateField}
                                        ref="tBabaAdi"
                                        value={this.state.memberInfo.babaAdi || ""}
                                        onChange={(e) => this.onChangeMemberUpperCase("babaAdi", e.target.value)} />
                                    {this.validateMessage('tBabaAdi') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tBabaAdi" delay={0}>
                                            {this.validateMessage("tBabaAdi")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">Ana Adı: *</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tAnaAdi')}>
                                    <input className="form-control"
                                        type="text"
                                        disabled={this.state.fieldsDisabled}
                                        name="anaAdi"
                                        id="tAnaAdi"
                                        maxLength="50"
                                        data-vlength="1,50"
                                        onBlur={this.validateField}
                                        ref="tAnaAdi"
                                        value={this.state.memberInfo.anaAdi || ""}
                                        onChange={(e) => this.onChangeMemberUpperCase("anaAdi", e.target.value)} />
                                    {this.validateMessage('tAnaAdi') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tAnaAdi" delay={0}>
                                            {this.validateMessage("tAnaAdi")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">Kimlik Tipi: *</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tKimlikTipi')}>
                                    <Select
                                        className="basic-single"
                                        disabled={this.state.fieldsDisabled}
                                        classNamePrefix="select"
                                        placeholder="Seçiniz"
                                        isClearable={false}
                                        isSearchable={false}
                                        name="kimlikTipi"
                                        id="tKimlikTipi"
                                        ref="tKimlikTipi"
                                        style={{ width: 160, minWidth: 160 }}
                                        inputProps={{ 'vdata': "required" }}
                                        options={KimlikTipiOptions}
                                        onChange={(value) => this.onSelectChange("kimlikTipi", value)}
                                        value={this.state.memberInfo.kimlikTipi} />
                                    {this.validateMessage('tKimlikTipi') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tKimlikTipi" delay={0}>
                                            {this.validateMessage("tKimlikTipi")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">N.Cüzdanı/TC Kimlik Seri No: *</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tCuzdanKimlikSeriNo')}>
                                    <input className="form-control"
                                        type="text"
                                        disabled={this.state.fieldsDisabled}
                                        name="cuzdanKimlikSeriNo"
                                        id="tCuzdanKimlikSeriNo"
                                        maxLength="50"
                                        data-vlength="1,50"
                                        onBlur={this.validateField}
                                        ref="tCuzdanKimlikSeriNo"
                                        value={this.state.memberInfo.cuzdanKimlikSeriNo || ""}
                                        onChange={(e) => this.onChangeMemberUpperCase("cuzdanKimlikSeriNo", e.target.value)} />
                                    {this.validateMessage('tCuzdanKimlikSeriNo') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tCuzdanKimlikSeriNo" delay={0}>
                                            {this.validateMessage("tCuzdanKimlikSeriNo")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>

                            {
                                (this.state.memberInfo.kimlikTipi === "NufusCuzdani") &&
                                <div className="row">
                                    <Label className="col-sm-3">Kimlik Kayıt No:</Label>
                                    <div className={"col-sm-8 form-group" + this.validateClass('tKayitNo')}>
                                        <input className="form-control"
                                            type="text"
                                            disabled={this.state.fieldsDisabled}
                                            name="KayitNo"
                                            id="tKayitNo"
                                            maxLength="50"
                                            data-vlength="1,50"
                                            onBlur={this.validateField}
                                            ref="tKayitNo"
                                            value={this.state.memberInfo.kayitNo || ""}
                                            onChange={(e) => this.onChangeMemberUpperCase("kayitNo", e.target.value)} />
                                        {this.validateMessage('tKayitNo') !== "" &&
                                            <UncontrolledTooltip placement="right" target="tKayitNo" delay={0}>
                                                {this.validateMessage("tKayitNo")}
                                            </UncontrolledTooltip>}
                                    </div>
                                </div>
                            }
      {
                                (this.state.memberInfo.kimlikTipi === "TCKimlikKarti")
                                    ?
                                    <div className="row">
                                        <Label className="col-sm-3">Kimlik Son Geçerlilik Tarihi:</Label>
                                        <div
                                            className={"col-sm-8 form-group" + this.validateClass('tKimlikSonGecerlilikTarihi')}>
                                            <DatePicker {...tKimlikSonGecerlilikTarihi}
                                                        className="basic-single"
                                                        placeholder="Tarih seçiniz."
                                                        disabled={this.state.fieldsDisabled}
                                                        classNamePrefix="select"
                                                        format="DD.MM.YYYY"
                                                        isClearable={true}
                                                        isSearchable={true}
                                                        name="kimlikSonGecerlilikTarihi"
                                                        id="tKimlikSonGecerlilikTarihi"
                                                        ref="tKimlikSonGecerlilikTarihi"
                                                        style={{width: 160}}
                                                        inputProps={{'vdata': "required"}}
                                                        onChange={(date, dateString) => this.onChangeDateString("kimlikSonGecerlilikTarihi", dateString)}/>
                                            {this.validateMessage('tKimlikSonGecerlilikTarihi') !== "" &&
                                            <UncontrolledTooltip placement="right" target="tKimlikSonGecerlilikTarihi"
                                                                 delay={0}>
                                                {this.validateMessage("tKimlikSonGecerlilikTarihi")}
                                            </UncontrolledTooltip>}
                                        </div>
                                    </div>
                                    :
                                    ""
                            }
                            <div className="row">
                                <Label className="col-sm-3">Doğum Yeri: *</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tDogumYeri')}>
                                    <input className="form-control"
                                        type="text"
                                        disabled={this.state.fieldsDisabled}
                                        name="dogumYeri"
                                        id="tDogumYeri"
                                        maxLength="50"
                                        data-vlength="1,50"
                                        onBlur={this.validateField}
                                        ref="tDogumYeri"
                                        value={this.state.memberInfo.dogumYeri || ""}
                                        onChange={(e) => this.onChangeMemberUpperCase("dogumYeri", e.target.value)} />
                                    {this.validateMessage('tDogumYeri') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tDogumYeri" delay={0}>
                                            {this.validateMessage("tDogumYeri")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">Medeni Hali: *</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tMedeniHali')}>
                                    <Select
                                        className="basic-single"
                                        disabled={this.state.fieldsDisabled}
                                        classNamePrefix="select"
                                        placeholder="Seçiniz"
                                        isClearable={false}
                                        isSearchable={false}
                                        name="medeniHal"
                                        id="tMedeniHali"
                                        ref="tMedeniHali"
                                        style={{ width: 160, minWidth: 160 }}
                                        inputProps={{ 'vdata': "required" }}
                                        options={medeniHalOptions}
                                        onChange={(value) => this.onSelectChange("medeniHali", value)}
                                        value={this.state.memberInfo.medeniHali} />
                                    {this.validateMessage('tMedeniHali') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tMedeniHali" delay={0}>
                                            {this.validateMessage("tMedeniHali")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Kan Grubu:</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tKanGrubu')}>
                                    <input className="form-control"
                                        type="text"
                                        disabled={this.state.fieldsDisabled}
                                        name="kanGrubu"
                                        id="tKanGrubu"
                                        maxLength="7"
                                        onBlur={this.validateField}
                                        style={{ width: 160, minWidth: 160 }}
                                        value={this.state.memberInfo.kanGrubu || ""}
                                        onChange={(e) => this.onChangeMemberUpperCase("kanGrubu", e.target.value)} />
                                    {this.validateMessage('tKanGrubu') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tKanGrubu" delay={0}>
                                            {this.validateMessage("tKanGrubu")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>
                        </div>
                        <div className="FormRenk col-sm-12">
                            <span className="form-title">İletişim Bilgileri</span>
                            <div className="row">
                                <Label className="col-sm-3">Cep Telefonu: *</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tGsmTel')}>
                                    <input className="form-control"
                                        type="text"
                                        disabled={this.state.fieldsDisabled}
                                        placeholder='1234567890'
                                        name="gsmTel"
                                        id="tGsmTel"
                                        maxLength="10"
                                        data-vlength="10"
                                        onBlur={this.validateField}
                                        ref="tGsmTel"
                                        value={this.state.memberInfo.gsmTel || ""}
                                        onChange={(e) => this.onChangeMember("gsmTel", e.target.value)} />
                                    {this.validateMessage('tGsmTel') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tGsmTel" delay={0}>
                                            {this.validateMessage("tGsmTel")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">İkamet Adresi: *</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tPermAdres')}>
                                    <TextArea className="form-control"
                                        type="text"
                                        disabled={this.state.fieldsDisabled}
                                        name="permAdres"
                                        id="tPermAdres"
                                        maxLength="255"
                                        style={{ height: 60, minHeight: 60 }}
                                        value={this.state.memberInfo.addressList[0] && this.state.memberInfo.addressList[0].addressString}
                                        onChange={(e) => this.onChangeAddress("addressString", e.target.value, 0, 'string')} />
                                    {this.validateMessage('tPermAdres') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tPermAdres" delay={0}>
                                            {this.validateMessage("tPermAdres")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>
                            <div className="row">
                                    <Label className="col-sm-3">İkamet İl/İlçe: </Label>
                                    <div className={"col-sm-4 form-group" + this.validateClass('tPermAdrsCity')}>
                                        <Select
                                            className="basic-single"
                                            disabled={this.state.fieldsDisabled}
                                            classNamePrefix="select"
                                            placeholder="İl seçiniz."
                                            isClearable={false}
                                            isSearchable={true}
                                            name="permAdrsCity"
                                            id="tPermAdrsCity"
                                            style={{ flex: 0.9 }}
                                            options={this.state.permanentAdrsCities}
                                            onChange={(value) => this.onChangeAddress("cityId", value, 0, 'select')}
                                            value={this.state.memberInfo.addressList[0].cityId}
                                        />

                                        {this.validateMessage('tPermAdrsCity') !== "" &&
                                            <UncontrolledTooltip placement="right" target="tPermAdrsCity" delay={0}>
                                                {this.validateMessage("tPermAdrsCity")}
                                            </UncontrolledTooltip>}
                                    </div>
                                    <div className={"col-sm-4 form-group" + this.validateClass('tPermAdrsCitySub')}>
                                        <Select
                                            className="basic-single"
                                            disabled={this.state.fieldsDisabled}
                                            classNamePrefix="select"
                                            placeholder="İlçe seçiniz."
                                            isClearable={false}
                                            isSearchable={true}
                                            name="permAdrsCitySub"
                                            id="tPermAdrsCitySub"
                                            style={{ flex: 0.9 }}
                                            options={this.state.permanentAdrsCitySubdivisions}
                                            onChange={(value) => this.onChangeAddress("citysubdivisionId", value, 0, 'select')}
                                            value={this.state.memberInfo.addressList[0].citysubdivisionId}
                                            inputProps={{ 'vdata': "required" }}
                                        />
                                        {this.validateMessage('tPermAdrsCitySub') !== "" &&
                                            <UncontrolledTooltip placement="right" target="tPermAdrsCitySub" delay={0}>
                                                {this.validateMessage("tPermAdrsCitySub")}
                                            </UncontrolledTooltip>}
                                    </div>
            </div>
        

                            <div className="row">
                                <Label className="col-sm-3">Semt: </Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tPermSemt')}>
                                    <input className="form-control"
                                        type="text"
                                        disabled={this.state.fieldsDisabled}
                                        name="permSemt"
                                        id="tPermSemt"
                                        maxLength="20"
                                        value={this.state.memberInfo.addressList[0] && this.state.memberInfo.addressList[0].semt}
                                        onChange={(e) => this.onChangeAddress("semt", e.target.value, 0, 'string')} />
                                    {this.validateMessage('tPermSemt') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tPermSemt" delay={0}>
                                            {this.validateMessage("tPermSemt")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">Ev Telefonu:</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tEvTel')}>
                                    <input className="form-control"
                                        type="text"
                                        disabled={this.state.fieldsDisabled}
                                        placeholder='1234567890'
                                        name="evTel"
                                        id="tEvTel"
                                        maxLength="10"
                                        value={this.state.memberInfo.evTel || ""}
                                        onChange={(e) => this.onChangeMember("evTel", e.target.value)} />
                                    {this.validateMessage('tEvTel') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tEvTel" delay={0}>
                                            {this.validateMessage("tEvTel")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>
                        </div>
                        <div className="FormRenk col-sm-12">
                            <span className="form-title">İş Yeri Bilgileri</span>
                            <div className="row">
                                <Label className="col-sm-3">Kendi İş Yeri mi?:</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tKendiIsYeri')}>
                                    <input
                                        name="chkKendiIsYeri"
                                        disabled={this.state.fieldsDisabled || !this.state.memberInfo.uyeCalisiyor}
                                        type="checkbox"
                                        checked={this.state.memberInfo.kendiIsyeri}
                                        onChange={(e) => this.onChangeCheckBox("kendiIsyeri", e.target.checked)} />
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Mesul Müdür mü?:</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tmesulMudur')}>
                                    <input
                                        name="chkMesulMudur"
                                        disabled={this.state.fieldsDisabled || !this.state.memberInfo.uyeCalisiyor}
                                        type="checkbox"
                                        checked={this.state.memberInfo.mesulMudur}
                                        onChange={(e) => this.onChangeCheckBox("mesulMudur", e.target.checked)} />
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Çalışma Belgeli Personel mi?:</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tCalismaBelgeli')}>
                                    <input
                                        name="chkCalismaBelgeli"
                                        disabled={this.state.fieldsDisabled || !this.state.memberInfo.uyeCalisiyor}
                                        type="checkbox"
                                        checked={this.state.memberInfo.calismaBelgeli}
                                        onChange={(e) => this.onChangeCheckBox("calismaBelgeli", e.target.checked)} />
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Eczacı mı?:</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tEczaci')}>
                                    <input
                                        name="chkEczaci"
                                        disabled={this.state.fieldsDisabled || !this.state.memberInfo.uyeCalisiyor}
                                        type="checkbox"
                                        checked={this.state.memberInfo.eczaci}
                                        onChange={(e) => this.onChangeCheckBox("eczaci", e.target.checked)} />
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Temsilci mi?:</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tTemsilci')}>
                                    <input
                                        name="chkTemsilci"
                                        disabled={this.state.fieldsDisabled || !this.state.memberInfo.uyeCalisiyor}
                                        type="checkbox"
                                        checked={this.state.memberInfo.temsilci}
                                        onChange={(e) => this.onChangeCheckBox("temsilci", e.target.checked)} />
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Müessese Sahibi:</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tMuesseseSahibi')}>
                                    <input className="form-control"
                                        type="text"
                                        disabled={this.state.fieldsDisabled || !this.state.memberInfo.uyeCalisiyor}
                                        name="muesseseSahibi"
                                        id="tMuesseseSahibi"
                                        maxLength="50"
                                        value={this.state.memberInfo.muesseseSahibi || ""}
                                        onChange={(e) => this.onChangeMemberUpperCase("muesseseSahibi", e.target.value)} />
                                    {this.validateMessage('tMuesseseSahibi') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tMuesseseSahibi" delay={0}>
                                            {this.validateMessage("tMuesseseSahibi")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">Müessese/Kurum Adı:</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tMuesseseAdi')}>
                                    <input className="form-control"
                                        type="text"
                                        disabled={this.state.fieldsDisabled || !this.state.memberInfo.uyeCalisiyor}
                                        name="muesseseAdi"
                                        id="tMuesseseAdi"
                                        maxLength="100"
                                        value={this.state.memberInfo.muesseseAdi || ""}
                                        onChange={(e) => this.onChangeMemberUpperCase("muesseseAdi", e.target.value)} />
                                    {this.validateMessage('tMuesseseAdi') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tMuesseseAdi" delay={0}>
                                            {this.validateMessage("tMuesseseAdi")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">İş Yeri Telefonu:</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tIsTel')}>
                                    <input className="form-control"
                                        type="text"
                                        disabled={this.state.fieldsDisabled || !this.state.memberInfo.uyeCalisiyor}
                                        name="isTel"
                                        id="tIsTel"
                                        maxLength="10"
                                        value={this.state.memberInfo.isTel || ""}
                                        onChange={(e) => this.onChangeMember("isTel", e.target.value)} />
                                    {this.validateMessage('tIsTel') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tIsTel" delay={0}>
                                            {this.validateMessage("tIsTel")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">İş Yeri Adresi: *</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tWorkAdres')}>
                                    <TextArea className="form-control"
                                        type="text"
                                        disabled={this.state.fieldsDisabled || !this.state.memberInfo.uyeCalisiyor}
                                        name="workAdres"
                                        id="tWorkAdres"
                                        maxLength="255"
                                        style={{ height: 60, minHeight: 60 }}
                                        value={this.state.memberInfo.addressList[1] && this.state.memberInfo.addressList[1].addressString}
                                        onChange={(e) => this.onChangeAddress("addressString", e.target.value, 1, 'string')} />
                                    {this.validateMessage('tWorkAdres') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tWorkAdres" delay={0}>
                                            {this.validateMessage("tWorkAdres")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">İş Yeri İl/İlçe: </Label>
                                <div className={"col-sm-4 form-group" + this.validateClass('tWorkAdresCity')}>
                                    <Select
                                        className="basic-single"
                                        disabled={this.state.fieldsDisabled || !this.state.memberInfo.uyeCalisiyor}
                                        classNamePrefix="select"
                                        placeholder="İl seçiniz."
                                        isClearable={false}
                                        isSearchable={true}
                                        name="workAdresCity"
                                        id="tWorkAdresCity"
                                        style={{ flex: 0.9 }}
                                        options={this.state.workAdrsCities}
                                        onChange={(value) => this.onChangeAddress("cityId", value, 1, 'select')}
                                        value={this.state.memberInfo.addressList[1] && this.state.memberInfo.addressList[1].cityId} />
                                    {this.validateMessage('tWorkAdresCity') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tWorkAdresCity" delay={0}>
                                            {this.validateMessage("tWorkAdresCity")}
                                        </UncontrolledTooltip>}
                                </div>
                                <div className={"col-sm-4 form-group" + this.validateClass('tWorkAdresCitySub')}>
                                    <Select
                                        className="basic-single"
                                        disabled={this.state.fieldsDisabled || !this.state.memberInfo.uyeCalisiyor}
                                        classNamePrefix="select"
                                        placeholder="İlçe seçiniz."
                                        isClearable={false}
                                        isSearchable={true}
                                        name="workAdresCitySub"
                                        id="tWorkAdresCitySub"
                                        style={{ flex: 0.9 }}
                                        options={this.state.workAdrsCitySubdivisions}
                                        onChange={(value) => this.onChangeAddress("citysubdivisionId", value, 1, 'select')}
                                        value={this.state.memberInfo.addressList[1] && this.state.memberInfo.addressList[1].citysubdivisionId} />
                                    {this.validateMessage('tWorkAdresCitySub') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tWorkAdresCitySub" delay={0}>
                                            {this.validateMessage("tWorkAdresCitySub")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>




                            <div className="row">
                                <Label className="col-sm-3">Semt: </Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tWorkSemt')}>
                                    <input className="form-control"
                                        type="text"
                                        disabled={this.state.fieldsDisabled || !this.state.memberInfo.uyeCalisiyor}
                                        name="workSemt"
                                        id="tWorkSemt"
                                        maxLength="20"
                                        value={this.state.memberInfo.addressList[1] && this.state.memberInfo.addressList[1].semt}
                                        onChange={(e) => this.onChangeAddress("semt", e.target.value, 1, 'string')} />
                                    {this.validateMessage('tWorkSemt') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tWorkSemt" delay={0}>
                                            {this.validateMessage("tWorkSemt")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Müessese Ruhsatnamesi Belge No/Tarih:</Label>
                                <div className={"col-sm-4 form-group" + this.validateClass('tRuhsatNo')}>
                                    <input className="form-control"
                                        type="text"
                                        disabled={this.state.fieldsDisabled || !this.state.memberInfo.uyeCalisiyor}
                                        name="ruhsatNo"
                                        id="tRuhsatNo"
                                        maxLength="50"
                                        style={{ flex: 1 }}
                                        value={this.state.memberInfo.ruhsatNo || ""}
                                        onChange={(e) => this.onChangeMemberUpperCase("ruhsatNo", e.target.value)} />
                                    {this.validateMessage('tRuhsatNo') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tRuhsatNo" delay={0}>
                                            {this.validateMessage("tRuhsatNo")}
                                        </UncontrolledTooltip>}
                                </div>
                                <div className={"col-sm-4 form-group" + this.validateClass('tRuhsatTarihi')}>
                                    <DatePicker
                                        className="basic-single"
                                        placeholder="Tarih seçiniz."
                                        disabled={this.state.fieldsDisabled || !this.state.memberInfo.uyeCalisiyor}
                                        classNamePrefix="select"
                                        format="DD.MM.YYYY"
                                        isClearable={true}
                                        isSearchable={true}
                                        name="ruhsatTarihi"
                                        id="tRuhsatTarihi"
                                        style={{ flex: 1 }}
                                        onChange={(date, dateString) => this.onChangeDateString("ruhsatTarihi", dateString)} />
                                    {this.validateMessage('tRuhsatTarihi') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tRuhsatTarihi" delay={0}>
                                            {this.validateMessage("tRuhsatTarihi")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Vergi Dairesi:</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tVergiDairesiAd')}>
                                    <input className="form-control"
                                        type="text"
                                        disabled={this.state.fieldsDisabled || !this.state.memberInfo.uyeCalisiyor}
                                        name="vergiDairesiAd"
                                        id="tVergiDairesiAd"
                                        maxLength="50"
                                        value={this.state.memberInfo.vergiDairesiAd || ""}
                                        onChange={(e) => this.onChangeMemberUpperCase("vergiDairesiAd", e.target.value)} />
                                    {this.validateMessage('tVergiDairesiAd') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tVergiDairesiAd" delay={0}>
                                            {this.validateMessage("tVergiDairesiAd")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">Vergi No:</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tVergiNo')}>
                                    <input className="form-control"
                                        type="text"
                                        disabled={this.state.fieldsDisabled || !this.state.memberInfo.uyeCalisiyor}
                                        name="vergiNo"
                                        id="tVergiNo"
                                        maxLength="50"
                                        value={this.state.memberInfo.vergiNo || ""}
                                        onChange={(e) => this.onChangeMember("vergiNo", e.target.value)} />
                                    {this.validateMessage('tVergiNo') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tVergiNo" delay={0}>
                                            {this.validateMessage("tVergiNo")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>
                        </div>
                        <div className="FormRenk col-sm-12">
                            <span className="form-title">Dosya Yükleme</span>

                            <div className="row">
                                <Label className="col-sm-3">Kayıt Dilekçesi: *</Label>
                                <div className="col-sm-8 form-group">
                                    <Uploader2 onInfoChange={this.onChangeMember}
                                        fileName="kayitDilekceFile"
                                        thumbFileName="kayitDilekceThumbFile"
                                        filePathName="kayitDilekcePath"
                                        pathPrefix="kayitDilekce"
                                        memberTCKN={this.state.memberInfo.tcKimlikNo}
                                        filePath={this.state.memberInfo.kayitDilekcePath}
                                        file={this.state.memberInfo.kayitDilekceFile}
                                        thumb={this.state.memberInfo.kayitDilekceThumbFile}
                                        isDisabled={this.state.fieldsDisabled} />
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Özgeçmiş: *</Label>
                                <div className="col-sm-8 form-group">
                                    <Uploader2 onInfoChange={this.onChangeMember}
                                        fileName="ozgecmisFile"
                                        thumbFileName="ozgecmisThumbFile"
                                        filePathName="ozgecmisPath"
                                        pathPrefix="ozgecmis"
                                        memberTCKN={this.state.memberInfo.tcKimlikNo}
                                        filePath={this.state.memberInfo.ozgecmisPath}
                                        file={this.state.memberInfo.ozgecmisFile}
                                        thumb={this.state.memberInfo.ozgecmisThumbFile}
                                        isDisabled={this.state.fieldsDisabled} />
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Nüfus Cüz. Sureti: *</Label>
                                <div className="col-sm-8 form-group">
                                    <Uploader2 onInfoChange={this.onChangeMember}
                                        fileName="kimlikCuzdanFile"
                                        thumbFileName="kimlikCuzdanThumbFile"
                                        filePathName="kimlikCuzdanPath"
                                        pathPrefix="kimlik"
                                        memberTCKN={this.state.memberInfo.tcKimlikNo}
                                        filePath={this.state.memberInfo.kimlikCuzdanPath}
                                        file={this.state.memberInfo.kimlikCuzdanFile}
                                        thumb={this.state.memberInfo.kimlikCuzdanThumbFile}
                                        isDisabled={this.state.fieldsDisabled} />
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">İkametgah Sureti: *</Label>
                                <div className="col-sm-8 form-group">
                                    <Uploader2 onInfoChange={this.onChangeMember}
                                        fileName="ikametgahFile"
                                        thumbFileName="ikametgahThumbFile"
                                        filePathName="ikametgahPath"
                                        pathPrefix="ikametgah"
                                        memberTCKN={this.state.memberInfo.tcKimlikNo}
                                        filePath={this.state.memberInfo.ikametgahPath}
                                        file={this.state.memberInfo.ikametgahFile}
                                        thumb={this.state.memberInfo.ikametgahThumbFile}
                                        isDisabled={this.state.fieldsDisabled} />
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">Diploma Fotokopisi:</Label>
                                <div className="col-sm-8 form-group">
                                    <Uploader2 onInfoChange={this.onChangeMember}
                                        fileName="diplomaFile"
                                        thumbFileName="diplomaThumbFile"
                                        filePathName="diplomaPath"
                                        pathPrefix="diploma"
                                        memberTCKN={this.state.memberInfo.tcKimlikNo}
                                        filePath={this.state.memberInfo.diplomaPath}
                                        file={this.state.memberInfo.diplomaFile}
                                        thumb={this.state.memberInfo.diplomaThumbFile}
                                        isDisabled={this.state.fieldsDisabled} />
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">İmza Sirküsü: *</Label>
                                <div className="col-sm-8 form-group">
                                    <Uploader2 onInfoChange={this.onChangeMember}
                                        fileName="imzaSirküsFile"
                                        thumbFileName="imzaSirküsThumbFile"
                                        filePathName="imzaSirküsPath"
                                        pathPrefix="imzaSirküs"
                                        memberTCKN={this.state.memberInfo.tcKimlikNo}
                                        filePath={this.state.memberInfo.imzaSirküsPath}
                                        file={this.state.memberInfo.imzaSirküsFile}
                                        thumb={this.state.memberInfo.imzaSirküsThumbFile}
                                        isDisabled={this.state.fieldsDisabled} />
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Adli Sicil Belgesi: *</Label>
                                <div className="col-sm-8 form-group">
                                    <Uploader2 onInfoChange={this.onChangeMember}
                                        fileName="adliSicilFile"
                                        thumbFileName="adliSicilThumbFile"
                                        filePathName="adliSicilPath"
                                        pathPrefix="adlisicil"
                                        memberTCKN={this.state.memberInfo.tcKimlikNo}
                                        filePath={this.state.memberInfo.adliSicilPath}
                                        file={this.state.memberInfo.adliSicilFile}
                                        thumb={this.state.memberInfo.adliSicilThumbFile}
                                        isDisabled={this.state.fieldsDisabled} />
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Fotoğraf: *</Label>
                                <div className="col-sm-8 form-group">
                                    <Uploader2 onInfoChange={this.onChangeMember}
                                        fileName="fotoFile"
                                        thumbFileName="fotoThumbFile"
                                        filePathName="fotoPath"
                                        pathPrefix="foto"
                                        memberTCKN={this.state.memberInfo.tcKimlikNo}
                                        filePath={this.state.memberInfo.fotoPath}
                                        file={this.state.memberInfo.fotoFile}
                                        thumb={this.state.memberInfo.fotoThumbFile}
                                        isDisabled={this.state.fieldsDisabled} />
                                </div>
                            </div>

                            {this.state.memberInfo.calismaBelgeli &&
                                <div className="row">
                                    <Label className="col-sm-3">Çalışma Belgesi: *</Label>
                                    <div className="col-sm-8 form-group">
                                        <Uploader2 onInfoChange={this.onChangeMember}
                                            fileName="calismaBelgesiFile"
                                            thumbFileName="calismaBelgesiThumbFile"
                                            filePathName="calismaBelgesiPath"
                                            pathPrefix="calismaBelgesi"
                                            memberTCKN={this.state.memberInfo.tcKimlikNo}
                                            filePath={this.state.memberInfo.calismaBelgesiPath}
                                            file={this.state.memberInfo.calismaBelgesiFile}
                                            thumb={this.state.memberInfo.calismaBelgesiThumbFile}
                                            isDisabled={this.state.fieldsDisabled} />
                                    </div>
                                </div>
                            }
                        </div>

                        {
                            (this.state.mode === 'review') &&
                            <div className="row">
                                <Label className="col-sm-3">Reddedilme Nedeni: *</Label>
                                <div
                                    className={"col-sm-8 form-group" + this.validateClass('tBasvuruReddedilmeSebebi')}>
                                    <TextArea className="form-control"
                                        type="text"
                                        name="basvuruReddedilmeSebebi"
                                        id="tBasvuruReddedilmeSebebi"
                                        maxLength="255"
                                        value={this.state.memberInfo.basvuruReddedilmeSebebi}
                                        onChange={(e) => this.onChangeMemberUpperCase("basvuruReddedilmeSebebi", e.target.value)} />
                                    {this.validateMessage('tBasvuruReddedilmeSebebi') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tBasvuruReddedilmeSebebi"
                                            delay={0}>
                                            {this.validateMessage("tBasvuruReddedilmeSebebi")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>
                        }
                    </Form>

                    {/* {
                        (this.state.mode === 'review') &&
                        <div className="row">
                            <div className="col">
                                {
                                    (this.state.memberInfo.basvuruDurumu !== 'ONAYLANDI') &&
                                    <button style={{ background: "#ffc107" }} onClick={() => {
                                        this.saveMember("ONAYA_GONDER")
                                    }} className="login-form-button">ONAYA GÖNDER</button>
                                }


                            </div>
                        </div>
                    } */}
                
                {
                    (this.state.memberInfo.basvuruDurumu !=="ONAYLANDI") &&
                    <div className="save-button-container">
                        <button onClick={() => {
                            this.saveMember("KAYDET")
                        }}
                            className="member-save-button"
                         //   disabled={this.state.isLoading || this.state.memberInfo.isTransferred}>
                         disabled={this.state.fieldsDisabled}>
                                ONAYA GÖNDER
                        </button>

                                <button
                                    onClick={this.saveDraft}
                                    className="member-save-button"
                                    disabled={this.state.fieldsDisabled}>

                                
                                    TASLAK KAYDET
                                </button>
                    </div>
        }
                

                    
                </div>
            </div>
        )
    }
}

export default NewMemberCreate;


// WEBPACK FOOTER //
// ./src/page/memberList/NewMemberCreate.js